import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { KomodoBadgeComponent } from '@app/modules/komodo-badge/components/komodo-badge/komodo-badge.component';

@NgModule({
    declarations: [
        KomodoBadgeComponent
    ],
    imports: [],
    exports: [
        KomodoBadgeComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class KomodoBadgeModule {
}
